import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
import ProfileTab from '../../components/dashboard/ProfileTab';
import PrivacyControls from '../../components/PrivacyControls';
import { useAuth } from '../../contexts/AuthContext';
import { useUsers } from '../../hooks/useUsers';

const ProfilePage = () => {
  const { user } = useAuth();
  const { ownerId } = useUsers();
  const isOwner = !!ownerId && user?._id === ownerId;

  return (
    <Box minH="100%" py={{ base: 4, md: 6 }}>
      <VStack align="stretch" spacing={6}>
        <ProfileTab />
        {isOwner && <PrivacyControls />}
      </VStack>
    </Box>
  );
};

export default ProfilePage;